import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { openAdobeExchange } from '../utils/analytics';
import {
  useLandingNamespace,
  useLanguageLanding,
} from '../context/LanguageLandingContext';
import './Demo.css';
import { isSafariBrowser, scrollReveal } from '../utils/safariMotion';

const Demo: React.FC = () => {
  const safari = isSafariBrowser();
  const { language } = useLanguageLanding();
  const ns = useLandingNamespace();
  const { t } = useTranslation(ns);

  const handleTryFree = () => {
    openAdobeExchange('demo', { language: language?.slug ?? null });
  };

  return (
    <section id="demo" className="demo">
      <div className="demo-container">
        <motion.div
          className="demo-header"
          transition={{ duration: 0.8, ease: 'easeOut' }}
          {...scrollReveal(safari, { opacity: 0, y: 30 }, { opacity: 1, y: 0 }, 'section')}
        >
          <motion.h2
            className="demo-title"
            transition={{ duration: 0.6, delay: 0.2 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}
          >
            {t('demoTitle')}
          </motion.h2>
          <motion.p
            className="demo-subtitle"
            transition={{ duration: 0.6, delay: 0.4 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}
          >
            {t('demoSubtitle')}
          </motion.p>
        </motion.div>

        <motion.div
          className="demo-video-container"
          transition={{ duration: 0.8, delay: 0.6 }}
          {...scrollReveal(safari, { opacity: 0, y: 30 }, { opacity: 1, y: 0 }, 'section')}
        >
          <div className="video-wrapper">
            <iframe
              src="https://player.vimeo.com/video/1133185730?h=0&autoplay=0&title=0&byline=0&portrait=0&controls=1&dnt=1"
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Substyle Demo Video"
              className="demo-video"
            />
          </div>
        </motion.div>

        <motion.div
          className="demo-cta"
          transition={{ duration: 0.6, delay: 0.8 }}
          {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}
        >
          <motion.button
            className="cta-button primary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleTryFree}
          >
            {t('installCta')}
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Demo;
